import type { AuthBackend, Session, SignOutArgs } from "../types";
import { getAuthHeaders, getSession } from "./getSession";
import { signInWithRedirect } from "./signIn";
import { signOut } from "./signOut";

export class TrimbleAuthBackend implements AuthBackend {
  readonly navigatesOnSignOut = true;

  signInWithRedirect(args?: { returnTo?: string }): Promise<void> {
    return signInWithRedirect(args);
  }

  signOut(args?: SignOutArgs): Promise<void> {
    return signOut(args);
  }

  getSession(): Promise<Session | null> {
    return getSession();
  }

  getAuthHeaders(): Promise<Record<string, string>> {
    return getAuthHeaders();
  }

  /** @deprecated See AuthBackend.shouldUseCredentialsInclude. */
  shouldUseCredentialsInclude(): boolean {
    return false;
  }
}

export const trimbleAuthBackend = new TrimbleAuthBackend();
